@use "./Header.module.scss" as *;
@use "../../styles/breakpoint.module.scss" as *;

.panel {
    position: fixed;
    top: $main-nav-height;
    left: 0;
    right: 0;
    box-shadow: 0 4px 8px rgb(from var(--black) r g b / 12%);
    max-height: calc(100dvh - #{$main-nav-height});
    overflow-y: auto;
    padding-block: var(--spacer-40);
    z-index: 13;
}

.mobilePanel {
    composes: panel;
    top: $mobile-nav-height;
    width: calc(100vw - 16px);
    height: calc(100dvh - #{$mobile-nav-height});

    @media ($below-mobile) {
        & :is(.popularSearches, .searchForm, .searchFormFull) {
            grid-column: 1 / -1;
        }

        .popularSearches {
            order: 1;
            margin-top: 40px;
        }
    }
}

.closeButtonWrapper {
    position: fixed;
    top: 0;
    left: max(var(--labui-container-margin), env(safe-area-inset-left));
    display: flex;
    align-items: center;
    height: $mobile-nav-height;
    z-index: 14;
}

.content {
    composes: safeGridContainer from "../../styles/composable/layout.module.css";
    display: flex;
    gap: var(--spacer-40);

    .mobilePanel & {
        flex-direction: column;
    }
}

.popularSearches {
    grid-column: span 3;

    @media ($below-mobile) {
        grid-column: span 1;
    }
}

.searchForm {
    grid-column: span 9;

    &:focus-visible {
        outline: var(--outline);
        outline-offset: 1px;
    }

    @media ($below-mobile) {
        grid-column: span 3;
    }
}

.searchFormFull {
    grid-column: 1 / -1;
}

.inputRow {
    display: flex;
    align-items: center;
    border-bottom: 1px solid var(--black);
    gap: var(--spacer-8);
}

.input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font: var(--font-h-24-forma);
    height: 40px;
    color: var(--black);

    &::placeholder {
        color: var(--gray-500);
    }

    &::-webkit-search-cancel-button {
        appearance: none;
    }
}

.clearButton,
.searchButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
}

.clearIcon,
.searchIcon {
    width: 24px;
    height: 24px;
    fill: var(--black);
}
